/**
 * WhoSummary
 *
 * Summary view for the WHO section.
 * Shows: "all accounts" or "X filter(s)"
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AutomationItem, FilterGroup } from '../types';

export interface WhoSummaryProps {
  automation: AutomationItem;
}

/**
 * Recursively count all filter nodes in a filter group
 */
const countFilters = (group: FilterGroup | null | undefined): number => {
  if (!group || !group.filters) return 0;

  return group.filters.reduce((count, filter) => {
    if ('condition' in filter) {
      // It's a nested FilterGroup
      return count + countFilters(filter as FilterGroup);
    }
    // It's a FilterNode
    return count + 1;
  }, 0);
};

export const WhoSummary: FC<WhoSummaryProps> = ({ automation }) => {
  const { t } = useTranslation();
  const filterCount = countFilters(automation.filters);

  if (filterCount > 0) {
    return <>{t('automations.who.filterCount', { count: filterCount })}</>;
  }
  return <>{t('automations.who.allAccounts')}</>;
};

